import { Fragment } from "react";
import { Box, Tooltip, Typography } from "@mui/material";

import { GeneralEntityChangeFragment } from "__generated__/components/entityHistory/graphql/entityHistory.fragments.generated";
import { intl } from "LocaleWrapper";
import EntityHistoryValue from "components/entityHistory/components/EntityHistoryValue";

const EntityHistoryPathLabels = ({ path, skipRoot = false }: {
	path: GeneralEntityChangeFragment["path"];
	skipRoot?: boolean;
}) => {
	const visible = skipRoot ? path.slice(1) : path;
	if (visible.length === 0) {
		return null;
	}

	return (
		<Box
			component="span"
			display="inline-flex"
			alignItems="center"
			flexWrap="wrap"
			gap={0.5}
		>
			{visible.map((segment, index) => (
				<Fragment key={`${segment.entityKey.name}-${segment.id}-${index}`}>
					{index > 0 && (
						<Typography component="span" fontSize={13} color="text.disabled">/</Typography>
					)}
					{segment.labels.map(label => (
						<Tooltip key={label.messageKey} title={`${intl.formatMessage({ id: segment.entityKey.languageKey })}: ${intl.formatMessage({ id: label.messageKey })}`}>
							<Box component="span">
								<EntityHistoryValue
									value={label.value}
									component="span"
									fontSize={13}
									fontWeight={500}
									color="text.primary"
								/>
							</Box>
						</Tooltip>
					))}
				</Fragment>
			))}
		</Box>
	);
};

export default EntityHistoryPathLabels;
